export default __webpack_public_path__ + "img/background_yellow.png";